import { Tabs } from '@mui/material';
import { withStyles } from '@mui/styles';

const ExpenseTabs = withStyles({
    root: {
        minHeight: 0,
    },
    flexContainer: {
        gap: 4,
    },
})((props) => <Tabs indicatorColor="primary" {...props} />);

export default ExpenseTabs;
